import { Component, OnInit } from '@angular/core';
import { DataEntityEditorBaseComponent } from '../../data-entity-editor-base/data-entity-editor-base.component';

@Component({
    selector: 'wm-sketch-data-entity-editor',
    templateUrl: './sketch-data-entity-editor.component.html',
    styleUrls: ['./sketch-data-entity-editor.component.css'],
    standalone: false
})
export class SketchDataEntityEditorComponent
  extends DataEntityEditorBaseComponent
  implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {}
}
